<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
      @on-load="onLoad"
    >
      <template slot="menuLeft">
        <el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          plain
          v-if="permission.parkpassinrule_delete"
          @click="handleDelete"
          >删 除
        </el-button>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import { add, getDetail, getList, remove, update } from '@/api/v4ward/park/pass/parkpassinrule';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        height: 'auto',
        calcHeight: 30,
        tip: false,
        searchShow: true,
        searchMenuSpan: 6,
        border: true,
        index: true,
        viewBtn: true,
        selection: true,
        refreshBtn:false,
        dialogClickModal: false,
        column: [
          {
            label: '',
            prop: 'id',
            rules: [
              {
                required: true,
                message: '请输入',
                trigger: 'change',
              },
            ],
          },
          {
            label: '车场ID',
            prop: 'parkingLotId',
            rules: [
              {
                required: true,
                message: '请输入车场ID',
                trigger: 'change',
              },
            ],
          },
          {
            label: '规则名称',
            prop: 'ruleName',
            rules: [
              {
                required: true,
                message: '请输入规则名称',
                trigger: 'change',
              },
            ],
          },
          {
            label: '通道id',
            prop: 'passageId',
            rules: [
              {
                required: true,
                message: '请输入通道id',
                trigger: 'change',
              },
            ],
          },
          {
            label: '出口无费用车是否自动放行： 0否 1是;',
            prop: 'freeCarPass',
            rules: [
              {
                required: true,
                message: '请输入出口无费用车是否自动放行： 0否 1是;',
                trigger: 'change',
              },
            ],
          },
          {
            label: '出口军警车牌是否自动放行： 0否 1是;',
            prop: 'policeCarPassOut',
            rules: [
              {
                required: true,
                message: '请输入出口军警车牌是否自动放行： 0否 1是;',
                trigger: 'change',
              },
            ],
          },
          {
            label: '出口过期月卡车计费方式：1按临停套餐、2按月卡车',
            prop: 'expiredCarFeeType',
            rules: [
              {
                required: true,
                message: '请输入出口过期月卡车计费方式：1按临停套餐、2按月卡车',
                trigger: 'change',
              },
            ],
          },
          {
            label: '出口无牌车是否自动放行： 0否 1是;',
            prop: 'noPlatePassOut',
            rules: [
              {
                required: true,
                message: '请输入出口无牌车是否自动放行： 0否 1是;',
                trigger: 'change',
              },
            ],
          },
          {
            label: '备注信息',
            prop: 'remark',
            rules: [
              {
                required: true,
                message: '请输入备注信息',
                trigger: 'change',
              },
            ],
          },
          {
            label: '版本',
            prop: 'version',
            rules: [
              {
                required: true,
                message: '请输入版本',
                trigger: 'change',
              },
            ],
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.parkpassinrule_add, false),
        viewBtn: this.vaildData(this.permission.parkpassinrule_view, false),
        delBtn: this.vaildData(this.permission.parkpassinrule_delete, false),
        editBtn: this.vaildData(this.permission.parkpassinrule_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  methods: {
    rowSave(row, done, loading) {
      add(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowUpdate(row, index, done, loading) {
      update(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
  },
};
</script>

<style></style>
